import { FC, MouseEventHandler } from 'react';
import {
  LinkStoryblok,
  NewsLetterStoryblok,
  PrivacySettingsStoryblok,
  ReturnOrderButtonStoryblok,
  TextStoryblok,
} from 'storyblok-types';
import { Image } from 'atoms/Image/Image';
import { StoryBlokLink } from 'atoms/StoryBlokLink';
import { Span } from 'atoms/Typography';
import { ReactMarkdown } from 'molecules/Markdown';
import { ReturnOrderButton } from 'pages/StoryBlok/ReturnOrderButton';
import styles from './styles.module.css';

export const Item: FC<
  | LinkStoryblok
  | TextStoryblok
  | PrivacySettingsStoryblok
  | ReturnOrderButtonStoryblok
  | (NewsLetterStoryblok & { onClick?: () => void })
  | ReturnOrderButtonStoryblok
> = ({ component: type, onClick, ...props }) => {
  if (type === 'Link') {
    const imageSrc = props.image?.filename;
    const imageAlt = props.image?.alt;
    const hasImage = !!imageSrc?.length;

    const handleLinkClick: MouseEventHandler = () => {
      onClick?.();
    };

    return (
      <>
        <StoryBlokLink
          link={props.parameters}
          className={styles.link}
          onClick={handleLinkClick}
        >
          {hasImage ? (
            <Image src={imageSrc} className={styles.image} alt={imageAlt} />
          ) : (
            props.text
          )}
        </StoryBlokLink>
        {hasImage && (
          <ReactMarkdown className={styles.smallText} text={props.text || ''} />
        )}
      </>
    );
  } else if (type === 'Text') {
    return <ReactMarkdown className={styles.text} text={props.text || ''} />;
  } else if (type === 'PrivacySettings') {
    const handlePrivacyClick = () => {
      window?.UC_UI?.showSecondLayer();
    };

    return (
      <Span className={styles.link} onClick={handlePrivacyClick}>
        {props.text}
      </Span>
    );
  } else if (type === 'returnOrderButton') {
    return <ReturnOrderButton text={props.text} className={styles.button} />;
  }

  return null;
};
